var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","dense":"","clipped-left":""}},[_c('v-toolbar-title',[_vm._v("Dante6")]),_c('v-spacer'),_vm._t("actions")],2),_c('v-main',[_c('v-container',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }